import { AbstractFormArgument } from './global'

class FormArgument extends AbstractFormArgument {
  constructor () {
    super()
    this.token = ''
    this.id = ''
    this.crmCode = ''
    this.userId = ''
    this.userName = ''
  }
}

class EmployeeFormArgument extends AbstractFormArgument {
  constructor () {
    super()

    this.date = ''
    this.itemId = ''
    this.userId = ''
    this.crmCode = 'ec'
    this.userName = ''
  }
}

export {
  FormArgument,
  EmployeeFormArgument
}



// WEBPACK FOOTER //
// ./src/models/ec-notice.js